export default __webpack_public_path__ + "static/media/adobe-logo.07d91cc5.svg";